var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React from "react";
import { useNavigate } from "react-router-dom";
import ErrorNotification, { ErrorDisplayType, } from "../Generic/ErrorNotification";
import { LogoLoader } from "../../../shared-library/components/Loader";
import di from "../Login/di/index";
import { getQueryParameterName } from "@frameworks/salesjourney/utils/genericMethods";
var OtherApplicationLogin = function () {
    var token = getQueryParameterName("Token");
    var navigate = useNavigate();
    var _a = __read(React.useState(), 2), serverError = _a[0], setServerError = _a[1];
    var _b = __read(React.useState(false), 2), isShowLoginFailedPopup = _b[0], setIsShowLoginFailedPopup = _b[1];
    var _c = __read(React.useState(true), 2), isShowLoader = _c[0], setIsShowLoader = _c[1];
    var handleSSOLogin = function () {
        di.login
            .getLoginData({ authToken: token })
            .then(function (loginResponse) {
            if (loginResponse.loginResponse) {
                navigate("/dashboard", { replace: true });
            }
            else {
                if ((loginResponse === null || loginResponse === void 0 ? void 0 : loginResponse.loginError) !== null &&
                    (loginResponse === null || loginResponse === void 0 ? void 0 : loginResponse.loginError) !== undefined) {
                    setServerError(loginResponse.loginError);
                }
                setIsShowLoader(false);
                setIsShowLoginFailedPopup(true);
            }
        })
            .catch(function (error) {
            setServerError(error);
            setIsShowLoader(false);
            setIsShowLoginFailedPopup(true);
        });
    };
    React.useEffect(function () {
        if (token) {
            handleSSOLogin();
        }
        else {
            navigate("/login", { replace: true });
        }
    }, [token]);
    React.useEffect(function () {
        if (localStorage.getItem("inScope")) {
            localStorage.setItem("inScope", "NO");
        }
        else {
            localStorage.setItem("inScope", "YES");
        }
    }, []);
    var getSessionPopup = function () {
        if ((serverError === null || serverError === void 0 ? void 0 : serverError.getHttpCode()) === 401) {
            return true;
        }
        return false;
    };
    return (React.createElement(React.Fragment, null,
        isShowLoader && React.createElement(LogoLoader, null),
        React.createElement(ErrorNotification, { displayType: ErrorDisplayType.POPUP, isOpen: isShowLoginFailedPopup, error: serverError, showSessionPopup: getSessionPopup(), errMsg: serverError === null || serverError === void 0 ? void 0 : serverError.getMessage(), popUpTitle: "UnAuthorized Access!" })));
};
export default OtherApplicationLogin;
